import React from 'react';

import { SecondaryStylesContext } from '@neptune/compare-domain';

export function useSecondaryStylesContext() {
  return React.useContext(SecondaryStylesContext);
}
